/* "import "redux"" is auto-generated by Snack after importing from "react-redux" */
import "redux" // 3.7.2
// @TO-DO: Delete above after Snack fix this bug

import React, { Component } from 'react'
import { View, StyleSheet } from '../react-native'
import { connect } from 'react-redux' // 5.0.6
import { withRouter } from 'react-router-dom'

import { onFetchQuestions, onAnswer } from './../state/modules/AllActions'

import {
  QuizHeadline,
  Card,
  Pagination,
  Answer,
  Spinner, 
} from './../components'

import { withErrorBoundary } from './../error'
import { saveUserTime } from '../state/modules/user/Reducer'

class QuizScreen extends Component {

  componentDidMount() {
    this.startTimer = new Date().getTime()
    this.props.onFetchQuestions()
  }

  componentWillReceiveProps(nextProps) {
    const { numberOfQuestions, counter, isLoading, hasError } = nextProps 

    const isLastQuestion = counter === numberOfQuestions && !isLoading && !hasError
     if (isLastQuestion) {
       const end = new Date().getTime()
      this.props.saveUserTime(end - this.startTimer)
      this.props.history.push(('Result'))
     }
  }

  shouldComponentUpdate(nextProps) {
    return (nextProps.counter < nextProps.numberOfQuestions) | nextProps.hasError
  }
  
  handleAnswer = (value) => {
    const { questions, counter } = this.props
    const { question, correct_answer } = questions[counter]

    this.props.onAnswer({ question: { question, correct_answer }, chosen_option: value })
  }
  
  renderQuestion = () => {
    const { questions, numberOfQuestions, counter } = this.props
    const { category, question, correct_answer, incorrect_answers } = questions[counter]
    
    return (
      <View style={styles.container}>
        <QuizHeadline category={category} />
        <Card question={question} />
        <Pagination current={counter+1} total={numberOfQuestions} />
        <Answer onPress={this.handleAnswer} correctAnswer={correct_answer} incorrectAnswers={incorrect_answers}/>
      </View>
    )          
  }
  
  render() { 
    const { isLoading, hasError, errorMessage } = this.props
    let content = null//<Spinner />

    if (hasError) {
      throw new Error(errorMessage)
    }

    if (!isLoading) {
      content = this.renderQuestion()
    }

    return (
      <View style={styles.container}>
        {content}
      </View>
    )
  }
}

const mapStateToProps = ({ fetchQuestion: { questions, numberOfQuestions }, answer: { counter }, status: { hasError, errorMessage, isLoading } }) => {

  return { questions, numberOfQuestions, isLoading, counter, hasError, errorMessage }
}

const connectedQuizScreen = connect(mapStateToProps, { onFetchQuestions, onAnswer, saveUserTime })(QuizScreen)

export default withRouter(withErrorBoundary(connectedQuizScreen))

const styles = StyleSheet.create(
  {
    container:{
      flex: 1,
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: '#A2E4F9',
      height: '100vh',
      width: '100%',
    },
  }
)






// WEBPACK FOOTER //
// ./src/screens/QuizScreen.js